import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (req.url.includes('/auth/refresh')) {
    return next(req);
  }

  const token = auth.getToken();
  const withToken = (t: string) => req.clone({ setHeaders: { Authorization: `Bearer ${t}` } });
  const onRefreshError = (refreshErr: unknown) => {
    void router.navigate(['/auth/login']);
    return throwError(() => refreshErr);
  };

  // Proactive refresh when token is about to expire; degrade gracefully on failure
  if (token && auth.isTokenExpiringSoon()) {
    return auth.refresh().pipe(
      switchMap((newToken) => next(withToken(newToken))),
      catchError(() => next(withToken(token))),
    );
  }

  return next(token ? withToken(token) : req).pipe(
    catchError((err) => {
      if (err?.status === 401 && token) {
        return auth.refresh().pipe(
          switchMap((newToken) => next(withToken(newToken))),
          catchError(onRefreshError),
        );
      }
      return throwError(() => err);
    }),
  );
};
